// copied from people to do autocomplete via api search, be sure to add reducers to /reducers/index.js
// searches any collection, specify what aql_query
import {
  SEARCH_COLLECTION_REQUEST_START,
  SET_COLLECTION_DATA,
  SET_COLLECTION_ERROR,
  CLEAR_COLLECTION_DATA
} from 'shared/constants/actionTypes';
import { nooCommandDirect } from './nooApi';
import _SERVICES from 'shared/constants/socialServices';

const searchCollectionRequestStart = () => ({ type: SEARCH_COLLECTION_REQUEST_START });

const setCollectionData = data => ({
  type: SET_COLLECTION_DATA,
  payload: data
});

const setCollectionError = error => ({
  type: SET_COLLECTION_ERROR,
  payload: error
});

const decorate_fullname = ecoregion_data => {
  let fn = ecoregion_data.name;
  return [fn, null];
};

export const searchCollection = ({ name, searchParams }) => {
  // search
  return async (dispatch, getState) => {
    if (!name) {
      console.warn('searchCollection called, but missing name .... abort', name);
      return null;
    }
    if (getState().collection?.isRequesting) {
      console.warn(
        'searchCollection in process, but called again! skip the call.... searching for: ',
        name
      );
      return null;
    }

    dispatch(searchCollectionRequestStart());

    console.log('[redux/collection/actions] searchCollection for: ', name);

    const trimmedName = name.trim().toLowerCase();

    const payload = {
      query_name: searchParams.queryName,
      data: { name_string: trimmedName, ...searchParams }
    };
    const params = {
      payload,
      setLoading: () => {},
      setResponse: data => {
        // console.log('check response data format:', data?.result?.[0]?.matches);
        const collectionList = data?.result?.[0]?.matches?.map(ecoregion => {
          const pdata = ecoregion.data;
          let them = {
            _id: ecoregion._id,
            ...pdata
          };
          [them.fullname, them.source] = decorate_fullname(ecoregion.data);

          return them;
        });
        dispatch(setCollectionData(collectionList));
      },
      setResponseError: error => {
        dispatch(setCollectionError(error));
      }
    };
    nooCommandDirect('aql', params);
  };
};

export const clearCollection = () => ({ type: CLEAR_COLLECTION_DATA });
